import { FC } from "react";
import { Paper, Skeleton, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

export const SkeletonBotItem: FC = () => {
  const theme = useTheme();

  const paperSkeletonStyles = {
    border: `1px solid ${theme.palette.grey[300]}`,
    background: "none",
    paddingBottom: "0px",
    height: "95px",
    display: "flex",
    paddingTop: "2px",
    position: "relative",
    boxShadow: "0px 4px 12px -3px rgba(0, 0, 0, 0.10)",
  };

  return (
    <Paper elevation={0} className={"base-adron-paper"} sx={paperSkeletonStyles}>
      <Stack direction={"row"} sx={{ width: "100%" }} alignItems={"center"} spacing={2}>
        <Skeleton animation="wave" variant="circular" width={80} height={80} />
        <Box>
          <Skeleton
            sx={{ position: "relative", top: "-10px " }}
            animation="wave"
            variant="text"
            width={150}
            height={24}
          />
          <Skeleton animation="wave" variant="text" width={40} height={20} />
          <Skeleton animation="wave" variant="text" width={40} height={20} />
        </Box>
      </Stack>
    </Paper>
  );
};
